<template>
  <main class="login-page">
    <div class="login-aurora login-aurora-cyan" aria-hidden="true" />
    <div class="login-aurora login-aurora-violet" aria-hidden="true" />

    <section class="login-stage">
      <div class="login-hero" aria-label="ShareAI 品牌展示">
        <div class="login-visual" aria-hidden="true">
          <span class="login-orbit login-orbit-one" />
          <span class="login-orbit login-orbit-two" />
          <span class="login-glass-dot login-dot-one" />
          <span class="login-glass-dot login-dot-two" />
          <span class="login-glass-dot login-dot-three" />
          <span class="login-s-halo" />
          <img :src="glassSUrl" alt="" :draggable="false">
        </div>

        <div class="login-hero-copy">
          <h2>让每一次连接<br><span>都有灵感回应</span></h2>
          <div class="login-benefits" aria-label="产品特性">
            <span><i />稳定服务</span>
            <span><i />快速连接</span>
            <span><i />隐私保护</span>
          </div>
        </div>
      </div>

      <section class="login-card" aria-labelledby="login-title">
        <span class="login-card-glint" aria-hidden="true" />
        <div class="login-card-heading">
          <h1 id="login-title">欢迎回来</h1>
        </div>

        <form class="login-form" @submit.prevent="handleLogin">
          <label class="login-label" for="login-account">用户名 / 邮箱</label>
          <div class="login-input-shell">
            <svg width="21" height="21" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true">
              <path d="M128,20a108,108,0,0,0,0,216c22.27,0,45.69-6.73,62.64-18a12,12,0,1,0-13.29-20c-13,8.63-31.89,14-49.35,14a84,84,0,1,1,84-84c0,9.29-1.67,17.08-4.69,21.95-2.64,4.24-6,6.05-11.31,6.05s-8.67-1.81-11.31-6.05c-3-4.87-4.69-12.66-4.69-21.95V88a12,12,0,0,0-23.49-3.46,52,52,0,1,0,8.86,79.57C172.3,174.3,182.81,180,196,180c24.67,0,40-19.92,40-52A108.12,108.12,0,0,0,128,20Zm0,136a28,28,0,1,1,28-28A28,28,0,0,1,128,156Z" />
            </svg>
            <input
              id="login-account"
              v-model="formData.userToken"
              name="account"
              type="text"
              placeholder="请输入用户名或邮箱"
              autocomplete="username"
            >
          </div>

          <label class="login-label" for="login-password">密码</label>
          <div class="login-input-shell">
            <svg width="21" height="21" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true">
              <path d="M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm-72,78.63V184a8,8,0,0,1-16,0V158.63a24,24,0,1,1,16,0ZM160,80H96V56a32,32,0,0,1,64,0Z" />
            </svg>
            <input
              id="login-password"
              v-model="formData.password"
              name="password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="请输入密码"
              autocomplete="current-password"
            >
            <button
              class="login-password-toggle"
              type="button"
              :aria-label="showPassword ? '隐藏密码' : '显示密码'"
              @click="togglePasswordVisibility"
            >
              <svg v-if="showPassword" width="20" height="20" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true">
                <path d="M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z" />
              </svg>
              <svg v-else width="20" height="20" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true">
                <path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" />
              </svg>
            </button>
          </div>

          <div class="login-form-options">
            <button
              :class="['login-remember', { checked: rememberMe }]"
              type="button"
              role="checkbox"
              :aria-checked="rememberMe"
              @click="rememberMe = !rememberMe"
            >
              <span>
                <svg v-if="rememberMe" width="12" height="12" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true">
                  <path d="M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z" />
                </svg>
              </span>
              记住我
            </button>
            <a href="#/resetpwd" @click.prevent="goToResetPassword">忘记密码？</a>
          </div>

          <button class="login-submit" type="submit" :disabled="loading">
            <span>{{ loading ? '登录中...' : '登录' }}</span>
          </button>
        </form>

        <p class="login-register">还没有账号？ <a href="#/register" @click.prevent="goToRegister">立即注册</a></p>
        <p class="login-use-policy" role="note">
          使用声明：本站仅限授权用户使用，禁止未经授权的自动化分析、批量调用接口或抓取数据。
        </p>
      </section>
    </section>
  </main>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { login } from '../api/auth'
import glassSUrl from '../assets/shareai-glass-s-transparent.webp'
import toast from '../utils/toast'
import { readStorage, removeStorage, writeStorage } from '../utils/safeStorage'
import './LoginPage.css'

export default {
  name: 'LoginPage',
  setup() {
    const router = useRouter()

    const savedUsername = readStorage('localStorage', 'savedUsername')
    const savedPassword = readStorage('localStorage', 'savedPassword')

    const route = router.currentRoute.value
    const autoFillUsername = route.query.username || savedUsername
    const autoFillPassword = route.query.password || savedPassword
    const redirectAfterLogin = typeof route.query.redirect === 'string' &&
      route.query.redirect.startsWith('/') &&
      !route.query.redirect.startsWith('//')
      ? route.query.redirect
      : '/carlist'

    const formData = ref({
      userToken: autoFillUsername,
      password: autoFillPassword,
      token: ''
    })

    const rememberMe = ref(true)
    const loading = ref(false)
    const showPassword = ref(false)

    const handleLogin = async () => {
      if (!formData.value.userToken) {
        toast.error('请输入用户名或邮箱')
        return
      }

      if (!formData.value.password) {
        toast.error('请输入密码')
        return
      }

      loading.value = true

      try {
        const response = await login({
          userToken: formData.value.userToken,
          password: formData.value.password,
          token: formData.value.token
        })

        if (response.code === 1) {
          if (rememberMe.value) {
            writeStorage('localStorage', 'savedUsername', formData.value.userToken)
            writeStorage('localStorage', 'savedPassword', formData.value.password)
          } else {
            removeStorage('localStorage', 'savedUsername')
            removeStorage('localStorage', 'savedPassword')
          }

          // 路由守卫会再次向服务端确认会话；等待跳转完成前持续展示“登录中”。
          await router.push(redirectAfterLogin)
        } else if (response.code === 0 || response.code === -1) {
          toast.error(response.msg || '登录失败')
        } else {
          toast.error('未知错误')
        }
      } catch (error) {
        console.error('登录错误:', error)
        if (error.response) {
          const data = error.response.data
          if (data && data.msg) {
            toast.error(data.msg)
          } else if (error.response.status === 404) {
            toast.error('接口不存在，请检查配置')
          } else if (error.response.status === 500) {
            toast.error('服务器错误，请稍后重试')
          } else {
            toast.error('登录失败，请稍后重试')
          }
        } else if (error.request) {
          toast.error('网络超时，登录失败，请重试')
        } else {
          toast.error('请求失败，请稍后重试')
        }
      } finally {
        loading.value = false
      }
    }

    const goToRegister = () => router.push('/register')
    const goToResetPassword = () => router.push('/resetpwd')
    const togglePasswordVisibility = () => {
      showPassword.value = !showPassword.value
    }

    return {
      formData,
      rememberMe,
      loading,
      showPassword,
      glassSUrl,
      handleLogin,
      goToRegister,
      goToResetPassword,
      togglePasswordVisibility
    }
  }
}
</script>
